import {BUTTON_TYPES, EVENT_NAMES, MENU_TYPES} from '/enum/tealium.enum';
import {getAnalyticsUtilDefaultInstance} from '/util/analytics';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

export function generateOnTabPress({
  tabName,
  buttonName,
  reportName,
  lastPaidRank,
}: any) {
  // Track navigational click
  const trackNavigationalClick = (targetName: any) => {
    getAnalyticsUtilDefaultInstance().trackNavigationalClick({
      menuName: 'tab',
      targetName,
    });
  };

  const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
    eventName: EVENT_NAMES.navigationClick,
  });

  trackNavigationalClick(tabName);

  sendEvent({
    menuType: MENU_TYPES.tabs,
    buttonName: buttonName,
    buttonType: BUTTON_TYPES.text,
    screenName: reportName,
    lastPaidRank: lastPaidRank,
  });
}
